import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import editIcon from "../../../assets/icons/edit-icon-white.svg";
import emailIcon from "../../../assets/icons/email_white_icon.svg";
import phoneIcon from "../../../assets/icons/phone_white_icon.svg";
import addressIcon from "../../../assets/icons/address_white_icon.svg";
import addIcon from "../../../assets/icons/add_icon_white.svg";
import AddressModal from "../../AddressModal";
import { getAddresses } from "../../../utils/apis/address";
import { useDispatch, useSelector } from "react-redux";
const AddressDetails = () => {
  const dummyAddress = [
    {
      name: "Jenny Wilson",
      email: "jennywilson01@gmail.com",
      contact_no: "+011 (684) 555-0102",
      address: "1623 Hunningon Place, 8 Lousiville, Kentucky, 40220, Canada",
    },
    {
      name: "Jenny Wilson2",
      email: "jennywilson012@gmail.com",
      contact_no: "+011 (684) 555-2102",
      address: "1625 Hunningon Place, 8 Lousiville, Kentucky, 40220, Canada",
    },
    {
      name: "Jenny Wilson2",
      email: "jennywilson012@gmail.com",
      contact_no: "+011 (684) 555-2102",
      address: "1625 Hunningon Place, 8 Lousiville, Kentucky, 40220, Canada",
    },
    {
      name: "Jenny Wilson2",
      email: "jennywilson012@gmail.com",
      contact_no: "+011 (684) 555-2102",
      address: "1625 Hunningon Place, 8 Lousiville, Kentucky, 40220, Canada",
    },
  ];
  const [activeAddress, setActiveAddress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isEditVisible, setIsEditVisible] = useState(false);
  const dispatch = useDispatch();

  const [addresses, setaddresses] = useState([]);
  const { idToken, customLoading } = useSelector((state) => state.auth);
  useEffect(() => {
    getAddresses(idToken, dispatch).then((response) => {
      setaddresses(response?.data);
    });
  }, [customLoading]);

  const AddressData = ({ item, index }) => {
    return (
      <div
        className={`address_container ${index === activeAddress && "active_address"
          }`}
        onClick={() => setActiveAddress(index)}
      >
        <div className="address_wrapper">
          <div className="address_data">
            <div className="name">
              <p>
                {item?.first_name} {item?.last_name}
              </p>
            </div>
            <div className="email other_details">
              <img src={emailIcon} alt="" />

              <p>{item?.email}</p>
            </div>
            <div className="contact_no other_details">
              <img src={phoneIcon} alt="" />

              <p>{item?.number}</p>
            </div>
            <div className="address other_details">
              <img src={addressIcon} alt="" />
              <p>
                {item.apartment_no +
                  " " +
                  item.street_address +
                  " " +
                  item.city +
                  " " +
                  item.state +
                  " " +
                  item.country}
              </p>
            </div>
          </div>
          <div className="button_wrapper">
            <button
              className="edit_button"
              onClick={() => setIsEditVisible(!isEditVisible)}
            >
              Edit <img src={editIcon} alt="" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="bottom_section">
        <div className="address_detail_container">
          <div className="header_wrapper">
            <h2>Address Details</h2>
          </div>
          <div className="address_detail_wrapper">
            {addresses?.map((item, index) => (
              <AddressData
                onClick={() => setActiveAddress(index)}
                key={item.id}
                item={item}
                index={index}
              />
            ))}
          </div>
        </div>
        <div className="footer_section">
          <div className="new_address_button_wrapper">
            <button
              className="add_address_button"
              onClick={() => setIsVisible(!isVisible)}
            >
              <img src={addIcon} alt="" />
              Add New Address
            </button>
          </div>
          {/* <div className="save_del_button">
            <button className="standard-button">Save Changes</button>
            <button className="delete_button">Delete account</button>
          </div> */}
        </div>
      </div>
      {isEditVisible || isVisible ? (
        <div className="addressModal">
          <div
            className="addressModalOverlay"
            onClick={() => {
              setIsEditVisible(false);
              setIsVisible(false);
            }}
          >
            <AddressModal
              setIsVisible={setIsVisible}
              isVisible={isVisible}
              setIsEditVisible={setIsEditVisible}
              isEditVisible={isEditVisible}
              toEditAddress={isEditVisible ? addresses[activeAddress] : ""}
            />
          </div>
        </div>
      ) : null}
      {/* {isEditVisible && (
        <div className="addressModal">
          <div className="addressModalOverlay">
            <AddressModal setIsVisible={setIsVisible} isVisible={isVisible} />
          </div>
        </div>
      )}
      {isVisible && (
        <div className="addressModal">
          <div className="addressModalOverlay">
            <AddressModal setIsVisible={setIsVisible} isVisible={isVisible} />
          </div>
        </div>
      )} */}
    </>
  );
};

export default AddressDetails;
